export { default } from './SpeedDial';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/SpeedDial/index.js
// module id = 888
// module chunks = 2